module.exports = __webpack_public_path__ + "static/media/be-artist.5aae87b7.png";